import * as React from 'react'

import { Site } from '@envato/foundation-types'

import { IItem } from 'searchResults'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { config } from '../../../../common/config'
import Button from '../../button'
import Card from '../../categoryPage/elementsPromoItemsBlock/card/card'

import * as styles from './elementsItemsBlock.module.css'

interface ICta {
  url: string
  title: string
}

interface IElementItem extends IItem {
  marketID: number
  previews: IItem['previews']
  title: string
  author: string
  itemURL: string
}

interface IProps {
  data: IElementItem[]
  title: string
  subtitle?: string
  cta: ICta
  reportItemClick: (index: number, item: IItem, listName: string) => any
  currentSite: Site
}

const ELEMENTS_LOGO_URL =
  config.assets.PUBLIC_PATH + '/images/logo-envato-elements.svg'

export const addUTMParamsToURL = (url: string, currentSite: Site) => {
  return `${url}?utm_campaign=elements_mkttraffic_homepage_20200507&utm_medium=referral&utm_source=${currentSite}.net`
}

const ElementsItemsBlock = ({
  data,
  title,
  subtitle,
  cta,
  reportItemClick,
  currentSite
}: IProps) => {
  const items = data.map(item => ({
    ...item,
    imageRatios: {
      previewRatio: 300 / 590
    },
    itemURL: addUTMParamsToURL(item.itemURL, currentSite)
  }))

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <div className={styles.textArea}>
          <div>
            <header>
              <h2 className={styles.title}>{title}</h2>
              {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            </header>

            <img
              className={styles.logo}
              src={ELEMENTS_LOGO_URL}
              alt="Elements logo"
            />

            <Button
              className={styles.leftButton}
              type={Button.Type.Primary}
              href={addUTMParamsToURL(cta.url, currentSite)}
              onClick={() =>
                reportBlockClick('Go to Envato Elements', {
                  eventLabel: 'Go to Envato Elements'
                })
              }
            >
              {cta.title}
            </Button>
          </div>
        </div>

        <div className={styles.items}>
          {items.map((item, index) => (
            <div className={styles.item} key={index}>
              <div className={styles.itemContent}>
                <Card
                  {...item}
                  width={33.33}
                  onClick={() =>
                    reportItemClick(
                      index,
                      item,
                      'Block interaction;Go to Envato Elements'
                    )
                  }
                  showCTA
                />
              </div>
            </div>
          ))}
        </div>

        <Button
          type={Button.Type.Primary}
          className={styles.lowerButton}
          href={addUTMParamsToURL(cta.url, currentSite)}
          onClick={() =>
            reportBlockClick('Go to Envato Elements', {
              eventLabel: 'Go to Envato Elements'
            })
          }
        >
          {cta.title}
        </Button>
      </div>
    </section>
  )
}

export default ElementsItemsBlock
